  <section class="section-calendario notranslate" translate="no" aria-labelledby="calendario-title">
    <div class="animacao-calendario" *ngIf="isLoading">
      <div class="loader bolinhas" aria-live="polite">
        <div class="bolinha dot1"></div>
        <div class="bolinha dot2"></div>
        <div class="bolinha dot3"></div>
      </div>
      <p>Carregando Calendário...</p>
    </div>

    <div class="container" *ngIf="!isLoading">

      <div class="header-calendario"  aria-label="Navegação do calendário">
        <button (click)="goToPreviousMonth()" class="icone voltar-mes" aria-label="Ir para o mês anterior">Mês Anterior</button>
        <h2>{{ currentDate | date: 'MMMM yyyy' }}</h2>
        <button (click)="goToCurrentMonth()" class="icone avancar-mes"  aria-label="Ir para o mês atual">Mês Atual</button>
      </div>

      <div class="dias">
        <div *ngFor="let dia of listaDias"
            title="{{dia.descricao}}"
            class="dia"
            [ngClass]="{
                        'indisponivel': dia.estatusDia == 5,
                        'dia-sem-ocorrencia': dia.estatusDia == 2,
                        'dia-com-ocorrencia': dia.estatusDia == 3,
                        'dia-sem-marcacao': dia.estatusDia == 4,
                        'dia-atual': dia.estatusDia == 1
                      }"
            (click)="OnInserirOcorrenciaNaoOcorrencia(dia.data, dia.estatusDia)"
            role="button"
            tabindex="0"
            aria-label="Dia "
            >

          <p class="dia-semana notranslate" translate="no">{{ dia.diaDaSemana }}</p>
          <p class="numero">{{ dia.data| date: 'dd' }}</p>
        </div>
      </div>

      <div class="container legenda-calendario"  aria-labelledby="legenda-title">
        <p><b>Legenda: </b> Calendário</p>
        <div class="conteudo-legenda">
          <div class="box-legenda dia-atual">
            <i class="icone-dot" aria-hidden="true"></i> <p>Dia Atual</p>
          </div>
          <div class="box-legenda dia-sem-ocorrencia">
            <i class="icone-dot" aria-hidden="true"></i> <p>Dia sem ocorrência</p>
          </div>
          <div class="box-legenda dia-com-ocorrencia">
            <i class="icone-dot" aria-hidden="true"></i> <p>dia com ocorrência</p>
          </div>
          <div class="box-legenda dia-sem-marcacao">
            <i class="icone-dot" aria-hidden="true"></i> <p>dia sem marcação</p>
          </div>
          <div class="box-legenda indisponivel">
            <i class="icone-dot" aria-hidden="true"></i> <p>indisponível</p>
          </div>

        </div>
      </div>

    </div>



  </section>



  <app-modal *ngIf="showModalCalendarioOcorrencia" class="modal-calendario" aria-labelledby="modal-ocorrencia-title">
    <div class="container-conviva form-registro modal-envolvidos">
      <div class="header-modal-calendario">
        <h1 class="titulo-page">Deseja Inserir Ocorrencia?</h1>
        <a class="btn-fechar-modal" (click)="FecharModalCalendario()"  aria-label="Fechar modal">fechar</a>
      </div>
      <div class="container-btns">
        <input type="button" (click)="InserirOcorrencia()" class="btn_primary" value="Cadastrar Ocorrencia"  aria-label="Cadastrar Ocorrência"/>
        <input type="button" (click)="InserirNaoOcorrencia()" class="btn_outline" value="Cadastrar Não Ocorrencia" aria-label="Cadastrar Não Ocorrência"/>
      </div>
    </div>
  </app-modal>

  <app-modal *ngIf="showModalCadastraNaoOcorrencia" class="modal-ata-calendario" aria-labelledby="modal-nao-ocorrencia-title">
    <form [formGroup]="formHomeNaoOcorrencia">
      <div class="container-conviva form-registro modal-envolvidos">
        <div class="header-modal-ata">
          <h1 class="titulo-page">Não Ocorrencia</h1>
          <a class="btn-fechar-modal" (click)="FecharModalCadastroNaoOcorrencia()"  aria-label="Fechar modal">fechar</a>
        </div>
        <div class="descricao-modal-excluir">
          <span><strong>Dia: </strong>{{this.dataOcorrenciaNaoOcorrencia | date : 'dd-MM-yyyy'}}</span>
        </div>

        <div class="conteudo-textarea">
          <label for="text-registro">Faça uma breve descrição de como foi o dia escolar.</label>
          <textarea
            id="text-registro"
            name="text-registro"
            rows="6"
            cols="50"
            formControlName="dsChamado"
            name="dsChamado"
            minlength="50"
            (keyup)="OnChangeCountLetters()"
            [ngClass]="{ 'is-invalid': submitted && formNaoOco.dsChamado.errors }"
            aria-describedby="descricao-error"
          ></textarea>
          <p class="legenda-textarea">Quantidade de caracteres atual: {{qtdeCaracteresDescricao}}</p>
        </div>

        <div class="container-btns">
          <input type="button" (click)="InserirRegistroNaoOcorrencia()" class="btn_primary" value="Salvar"  aria-label="Salvar Não Ocorrência"/>
          <input type="button" (click)="FecharModalCadastroNaoOcorrencia()" class="btn_outline" value="Cancelar" aria-label="Cancelar"/>
        </div>
      </div>

    </form>
  </app-modal>
